module.exports = __webpack_public_path__ + "img/formularios.1ef8a690.svg";